import React, { useState } from 'react'
import { IconButton, Details, Toaster, Button } from '@ui'
import { FormGroup, Classes, InputGroup, Intent } from '@blueprintjs/core'
import { Dialog } from '@ui'
import { NavigateFn } from '@reach/router'
import { ApolloError } from 'apollo-boost'
import { handleErrors } from './Tableview'
import api from '@api'

type NewAssetProps = {
  reload?: () => void
  navigate?: NavigateFn
}

const NewAssetDialog: React.FunctionComponent<NewAssetProps> = ({
  reload,
  navigate,
}: NewAssetProps) => {
  const [name, setName] = useState('')
  const [errors, setErrors] = useState<React.ReactNode[]>([])
  const [loading, setLoading] = useState(false)

  const onClose = () => navigate && navigate(window.location.pathname)
  const formGroupProps = {
    intent: errors.length ? Intent.DANGER : undefined,
    helperText: errors,
  }
  return (
    <Dialog
      isOpen
      canEscapeKeyClose
      title="Create New Asset"
      isCloseButtonShown={false}
      transitionDuration={200}
      onClose={onClose}
      toolbar={
        <div className="dialog-buttons">
          <IconButton minimal iconName="times" onClick={onClose} tooltip="close" />
        </div>
      }
      body={
        <Details
          onSubmit={(e) => {
            setLoading(true)
            e.preventDefault()
            api.asset
              .create(name.trim())
              .then(() => {
                setName('')
                setLoading(false)
                setErrors([])
                reload?.()
                Toaster.success({ message: 'Asset Created' })
                onClose()
              })
              .catch((error: ApolloError) => {
                setLoading(false)
                setErrors(handleErrors(error))
              })
          }}
        >
          <div className={Classes.DIALOG_BODY}>
            <Details.Row>
              <Details.Label label="Name" required />
              <Details.Column>
                <FormGroup {...formGroupProps}>
                  <InputGroup
                    autoFocus
                    value={name}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setName(event.target.value)
                    }
                  />
                </FormGroup>
              </Details.Column>
            </Details.Row>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Create" intent="primary" type="submit" loading={loading} />
            </div>
          </div>
        </Details>
      }
    />
  )
}

export default NewAssetDialog
